import { useEffect, useState } from "react";
import { Button, Col, Row, Skeleton, Table } from "antd";
import * as XLSX from "xlsx";
import stemiColumns from "../custom/StemiData";

import {
  Notify,
  openNotification,
} from '@seims/shared';

function Preview({ file, setProgressState, onFileSubmit, recordLimit}) {
  const [previewData, setPreviewData] = useState([]);
  const [fileContents, setFileContents] = useState({
    name: "",
    size: "",
    contentLength: "",
    previewLength: "",
  });
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [disableUpload, setDisableUpload] = useState(false);

  useEffect(() => {
    onFileLoad();
  }, []);

  const columns = [
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Olympiad Name"])
              ? "red"
              : "inherit",
          }}
        >
          Olympiad Name
        </span>
      ),
      dataIndex: "Olympiad Name",
      key: "1",
      fixed: "left",
      width: 250,
      ellipsis: true,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Olympiad Date"])
              ? "red"
              : "inherit",
          }}
        >
          Olympiad Date
        </span>
      ),
      dataIndex: "Olympiad Date",
      key: "2",
      fixed: "left",
      width: 200,
      // render: (x) => (util.fromExcelNumDateToDate(x))
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Sector"])
              ? "red"
              : "inherit",
          }}
        >
          Sector
        </span>
      ),
      dataIndex: "Sector",
      key: "3",
      width: 120,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Category"])
              ? "red"
              : "inherit",
          }}
        >
          Category
        </span>
      ),
      dataIndex: "Category",
      key: "4",
      width: 150,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Sub Category"])
              ? "red"
              : "inherit",
          }}
        >
          Sub Category
        </span>
      ),
      dataIndex: "Sub Category",
      key: "5",
      width: 150,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Identifier"])
              ? "red"
              : "inherit",
          }}
        >
          Learner Identifier
        </span>
      ),
      dataIndex: "Learner Identifier",
      key: "6",
      width: 150,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Science Club Member"])
              ? "red"
              : "inherit",
          }}
        >
          Science Club Member
        </span>
      ),
      dataIndex: "Science Club Member",
      width: 150,
      key: "7",
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Race"])
              ? "red"
              : "inherit",
          }}
        >
          Learner Race
        </span>
      ),
      dataIndex: "Learner Race",
      width: 100,
      key: "8",
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Gender"])
              ? "red"
              : "inherit",
          }}
        >
          Gender
        </span>
      ),
      dataIndex: "Learner Gender",
      key: "9",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Disability"])
              ? "red"
              : "inherit",
          }}
        >
          Disability
        </span>
      ),
      dataIndex: "Learner Disability",
      key: "10",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Grade"])
              ? "red"
              : "inherit",
          }}
        >
          Grade
        </span>
      ),
      dataIndex: "Learner Grade",
      key: "11",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["School Name"])
              ? "red"
              : "inherit",
          }}
        >
          School Name
        </span>
      ),
      dataIndex: "School Name",
      key: "12",
      width: 200,
      ellipsis: true,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["School Quintile"])
              ? "red"
              : "inherit",
          }}
        >
          School Quintile
        </span>
      ),
      dataIndex: "School Quintile",
      key: "13",
      width: 120,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["School Type"])
              ? "red"
              : "inherit",
          }}
        >
          School Type
        </span>
      ),
      dataIndex: "School Type",
      key: "14",
      width: 120,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Province"])
              ? "red"
              : "inherit",
          }}
        >
          Province
        </span>
      ),
      dataIndex: "Province",
      key: "15",
      width: 120,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["District"])
              ? "red"
              : "inherit",
          }}
        >
          District
        </span>
      ),
      dataIndex: "District",
      key: "16",
      width: 150,
      ellipsis: true,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Round"])
              ? "red"
              : "inherit",
          }}
        >
          Round
        </span>
      ),
      dataIndex: "Round",
      key: "17",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: previewData.every((item) => !item["Learner Result"])
              ? "red"
              : "inherit",
          }}
        >
          Results
        </span>
      ),
      dataIndex: "Learner Result",
      key: "18",
      fixed: "right",
      width: 100,
    },
  ];

  const validateFile = (fileData) => {
    let isValid = true;
    if (fileData.length === 0) {
      openNotification(
        "File Validation",
        `${file.name} appears to be empty/corrupted, please re-upload`,
        Notify.ERROR
      );
      setProgressState(0);
      isValid = false;
      return isValid;
    }
    return isValid;
  };

  const onFileLoad = () => {
    const promise = new Promise((resolve, reject) => {
      setLoading(true);
      const fileReader = new FileReader();

      fileReader.readAsArrayBuffer(file);
      fileReader.onload = (e) => {
        const bufferArray = e.target.result;
        const wb = XLSX.read(bufferArray, { type: "buffer" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);
        const previewData = data.slice(0, 1000);

        const isValid = validateFile(previewData);

        if (!isValid) return;

        const { size, name } = file;
        const content = { ...fileContents };
        content.name = name;
        content.size = `${Math.round(size / 1024, 0)}KB`;
        content.contentLength = `${data.length} Rows`;
        content.previewLength = `${previewData.length} Rows`;

        setFileContents(content);

        const fileColums = Object.keys(data[0]);
        var colCount = 0;
        var nonMatchingCols = [];

        fileColums.forEach((column) => {
          if (stemiColumns.filter((x) => x === column)) {
            colCount += 1;
          }

          var found = stemiColumns.find((x) => x != column);
          nonMatchingCols.push(found && column);
        });

        const itemsNotFoundInSource = fileColums.filter(
          (sourceItem) => !stemiColumns.includes(sourceItem)
        );

        if (itemsNotFoundInSource.length > 0) {
          var messages = "";
          itemsNotFoundInSource.forEach((item, index) => {
            if (item != null) {
              if (index < itemsNotFoundInSource.length - 1)
                messages += `"${item}" column does not match the STEMI template;`;
              else
                messages += `"${item}" column does not match the STEMI template`;
            }
          });

          setDisableUpload(true);
          resolve(previewData);
          setPreviewData(previewData);
          setLoading(false);
          const showList = true;
          openNotification(
            `File Header Validation (${file.name})`,
            `${messages}`,
            Notify.ERROR,
            showList
          );
          return;
        }

        var finalCount = stemiColumns.length - colCount;

        if (previewData.length > 0 && finalCount === 0) {
          resolve(previewData);
          setPreviewData(previewData);
          setLoading(false);
        } else {
          const showList = true;
          openNotification(
            "File Validation",
            `${file.name} is either empty or does not comform to STEMI Olympiad template; System expected 18 columns but received ${fileColums.length}`,
            Notify.ERROR,
            showList
          );
          setProgressState(0);
        }

        if (data.length > recordLimit) {
          openNotification(
            "File Length Validation",
            `${file.name} has ${content.contentLength} of data, system expected ${recordLimit} or less`,
            Notify.ERROR
          );
          setProgressState(0);
        }
      };
      FileReader.onerror = (error) => {
        reject(error);
        setLoading(true);
      };
    });

    promise.then((dataItems) => {
      setPreviewData(dataItems.slice(0, 1000));
      // setLoading(false)
    });
  };

  const onUploadFile = () => {
    //Send request to the BE
    setProgressState(2);
    onFileSubmit(file);
  };

  const onRowChange = (row) => {
    setPageSize(row.pageSize);
  };

  const onBack = () => {
    setProgressState(0);
  };

  const isDisabled = (disabled) => {
    if (loading) return true;
    if (disabled) return true;
    if (!disabled) return false;
  };

  return (
    <>
      {loading ? (
        <Skeleton active avatar />
      ) : (
        <Table
          dataSource={previewData}
          columns={columns}
          loading={loading}
          rowKey={(record) =>
            record.STEMIOlympiadName + record["Learner Identifier"]
          }
          bordered
          pagination={{ pageSize: pageSize }}
          size="middle"
          scroll={{ x: "1500px" }}
          sticky
          onChange={onRowChange}
        />
      )}

      {!loading && (
        <div style={{ fontSize: "12px" }}>
          <div>
            <b>File name:</b> {fileContents.name}
          </div>
          <div>
            <b>File size:</b> {fileContents.size}
          </div>
          <div>
            <b>Total number of records:</b> {fileContents.contentLength}
          </div>
          <div>
            <b>Number of records on Preview:</b> {fileContents.previewLength}
          </div>
        </div>
      )}

      <Row>
        <Col xs={24} className="right-align">
          <Button
            className="right-align-button"
            onClick={onBack}
            type="deafult"
            style={{ marginTop: "20px" }}
          >
            Back
          </Button>{" "}
          &nbsp;
          <Button
            className="right-align-button"
            onClick={onUploadFile}
            htmlType="submit"
            type="primary"
            style={{ marginTop: "20px" }}
            disabled={isDisabled(disableUpload)}
          >
            Upload
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default Preview;
